import {lifecycle} from 'recompose';

export default lifecycle({

  componentDidUpdate(prevProps) {
    // Only run auto-selection logic once when data is first loaded
    const careUnitsJustLoaded = !prevProps.careUnits && this.props.careUnits;
    const opticianShopsJustLoaded = !prevProps.opticianShops && this.props.opticianShops;
    const opticianUsersJustLoaded = (!prevProps.opticianUsers || prevProps.opticianUsers.length === 0)
      && this.props.opticianUsers && this.props.opticianUsers.length > 0;

    // Auto-select care unit when data first loads
    const shouldAutoSelectCareUnit = careUnitsJustLoaded && !this.props.selectedCareUnit;
    if (shouldAutoSelectCareUnit) {
      const hasExactlyOneCareUnit = this.props.careUnits && this.props.careUnits.length === 1;
      const firstCareUnit = this.props.careUnits?.[0];
      const receiverNotAlreadySet = this.props.referral?.receiver?.organizationId !== firstCareUnit?.organizationId;

      if (hasExactlyOneCareUnit && receiverNotAlreadySet) {
        this.props.updateReferralValue("receiver.organizationId", firstCareUnit.organizationId)
      }
    }

    // Auto-select optician shop when data first loads
    const shouldAutoSelectOpticianShop = opticianShopsJustLoaded && !this.props.selectedOpticianShop;
    if (shouldAutoSelectOpticianShop) {
      // Scenario A: User is logged in to a specific optician - use their own shop
      const userHasLoggedInOrganization = this.props.opticianShops && this.props.loggedInOrganizationId;
      const senderNotSetToUserOrganization = this.props.referral?.sender?.organizationId !== this.props.loggedInOrganizationId;

      if (userHasLoggedInOrganization && senderNotSetToUserOrganization) {
        this.props.updateReferralValue("sender.organizationId", this.props.loggedInOrganizationId)
      }
      // Scenario B: Only one optician shop available - auto-select it
      else {
        const hasExactlyOneOpticianShop = this.props.opticianShops && this.props.opticianShops.length === 1;
        const firstOpticianShop = this.props.opticianShops?.[0];
        const senderNotAlreadySet = this.props.referral?.senderId !== firstOpticianShop?.organizationId;

        if (hasExactlyOneOpticianShop && senderNotAlreadySet) {
          this.props.updateReferralValue("sender.organizationId", firstOpticianShop.organizationId)
        }
      }
    }

    // Auto-select optician user when data first loads
    if (opticianUsersJustLoaded && this.props.loggedInUser && !this.props.referral?.opticianName) {
      const loggedInOptician = this.props.opticianUsers.find(u => u.username === this.props.loggedInUser);
      if (loggedInOptician) {
        const fullName = `${loggedInOptician.firstName || ''} ${loggedInOptician.lastName || ''}`.trim()
          || loggedInOptician.username;
        this.props.updateReferralValue("opticianName", fullName);
      }
    }
  },

  componentDidMount() {
    this.props.loadCareUnits();
    this.props.loadOpticianShops();
    this.props.loadOpticianUsers();
  }

});